import get from 'lodash/get';

export default {
  data() {
    return {
      errorMessage: null,
      errors: {},
    };
  },
  methods: {
    resetErrors() {
      this.errorMessage = null;
      this.errors = {};
    },
    handleXHRErrors(error) {
      let status = get(error, 'response.status');

      switch (status) {
        case 422:
          return this.handle422(error.response);
        default:
          this.errorMessage = 'There was a problem. Please try again.';
      }
    },
    handle422(response) {
      this.errorMessage = get(response, 'data.message', 'There was a problem. Please try again.');
      this.errors = get(response, 'data.errors', {});
    },

    hasErrors(field) {
      return this.getErrors(field).length > 0;
    },

    getErrors(field) {
      return get(this.errors, field, []);
    },
  },
};
